import { get } from 'lodash'

import * as ERRORS from 'Reducers/Errors/const'

const hasSameErrorMessage = (store, action) => {
  return (
    action.type === ERRORS.PUSH_API_ERROR &&
    get(store.getState(), 'errors.apiErrors').find(
      ({ message }) =>
        message === (action.error && action.error.message) ||
        action.message ||
        action.error,
    )
  )
}
export const errorMessageMiddleware = store => next => action => {
  if (
    action.type === ERRORS.PUSH_API_ERROR &&
    (action.error && action.error.message) === 'Ressouce does not exist'
  )
    return
  if (hasSameErrorMessage(store, action)) return

  next(action)
}
//test
